// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","BlogsPopularFeed":"jz_a bhi_qr bhi_a bhi_w","BlogsPopularFeed__loading":"jz_b"};